var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": "1000px",
        "content-class": "configuration-dialog",
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g({ attrs: { depressed: "", color: "warning" } }, on),
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("timer")]),
                  _vm._v("Schedule Execution\n    "),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _vm.dialog
        ? [
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { attrs: { flat: "", dark: "" } },
                  [
                    _c(
                      "v-toolbar",
                      { attrs: { dark: "", color: "primary" } },
                      [
                        _c("v-toolbar-title", [_vm._v("View Schedule Setup")]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", dark: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticStyle: { overflow: "auto" } },
              [
                _c("cron-picker-2", {
                  attrs: { rawCronString: _vm.configuration.cronString },
                  on: { saveCronSetup: _vm.saveCronSetup },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }